import { render, staticRenderFns } from "./StockOpnameResultDetailUpload.vue?vue&type=template&id=22dca96c&"
import script from "./StockOpnameResultDetailUpload.vue?vue&type=script&lang=js&"
export * from "./StockOpnameResultDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports